<template>
  <div>
    <div v-if="networkResponse && networkResponse.message" >
    </div>
    <div>
      <p>
        <span v-if="hasNonMfaFields">
          Please enter your contact information below and click on 'Next'.
        </span>
        <span v-if="hasMfaFields || (hasMfaFields && hasNonMfaFields)">Please enter your contact information below and click on 'Next'. Office email and Cell Phone will be used for future electronic Multi Factor Authentication (MFA). We will send you a login 
          code to your new office email and cell phone. Login code will be valid for limited time. Enter the login code on the following screen and upon successful login code validation your MFA 
          contact information will be updated along with the other contact information and you will be navigated to your RI DMV Online Customer profile.
        </span>
      </p>
      <div class="component-container" v-if="updateContact">
        
        <!-- Contact Name (No Confirm) -->
        <div v-if="updateContact.contactPersonName" class="field-group">
          <label for="contactName" class="field-label">Contact Name</label>
          <input 
            type="text" 
            id="contactName" 
            v-model="myContactName" 
            @input="validateContactNameField"
            class="app-input"
          />
          <span class="app-error-msg" v-if="!isValidContactName">
            {{errMsgContactName}}
          </span>
        </div>

        <!-- Office Email (With Confirm) -->
        <div v-if="updateContact.officeEmail" class="field-group">
          <ContactEmail :verify="verify" @doEmail="setEmail" @doResetVerify="resetVerify" :embedded="true" ref="contactEmailRef" @click.right.prevent :isRequired="false" titleEmail="Office Email"/>
          <span class="app-error-msg" v-if="!isValidOfficeEmail">
            {{errMsgOfficeEmail}}
          </span>
          <ContactEmail :verify="verify" @doEmail="setConfirmEmail" @doResetVerify="resetVerify" :embedded="true" titleEmail="Confirm Office Email" userEmail="ConfirmOfficeEmail"
           ref="contactReenterEmailRef" @click.right.prevent :isRequired="false" @paste.prevent/>
          <span class="app-error-msg" v-if="!isValidConfirmOfficeEmail">
            {{errMsgConfirmOfficeEmail}}
          </span>
          <span class="app-error-msg" v-if="!validateOfficeEmail && errMsgCommonOfficeEmail">
            {{errMsgCommonOfficeEmail}}
          </span>
        </div>

        <!-- Cell Phone (With Confirm) -->
        <div v-if="updateContact.cellPhone" class="field-group">
          <ContactPhone :verify="verify" @doPhone="setPhone" @doResetVerify="resetVerify" :embedded="true" ref="contactPhoneRef"
           @click.right.prevent titlePhone="Cell Phone (Message and data rates may apply)"/>
          <span class="app-error-msg" v-if="!isValidCellPhone">
            {{errMsgCellPhone}}
          </span>
          <ContactPhone :verify="verify" @doPhone="setConfirmPhone" @doResetVerify="resetVerify" :embedded="true" titlePhone="Confirm Cell Phone"
           ref="contactReenterPhoneRef" @click.right.prevent @paste.prevent/>
          <span class="app-error-msg" v-if="!isValidConfirmCellPhone">
            {{errMsgConfirmCellPhone}}
          </span>
          <span class="app-error-msg" v-if="!validateCellPhone && errMsgCommonCellPhone">
            {{errMsgCommonCellPhone}}
          </span>
        </div>

        <!-- Office Phone (No Confirm) -->
        <div v-if="updateContact.officePhone" class="field-group">
          <ContactPhone :verify="verify" @doPhone="setOfficePhone" @doResetVerify="resetVerify" :embedded="true" ref="officePhoneRef"
           @click.right.prevent titlePhone="Office Phone"/>
          <span class="app-error-msg" v-if="!isValidOfficePhone">
            {{errMsgOfficePhone}}
          </span>
        </div>

        <!-- Office Fax (No Confirm) -->
        <div v-if="updateContact.officeFax" class="field-group">
          <ContactPhone :verify="verify" @doPhone="setOfficeFax" @doResetVerify="resetVerify" :embedded="true" ref="officeFaxRef"
           @click.right.prevent titlePhone="Office Fax"/>
          <span class="app-error-msg" v-if="!isValidOfficeFax">
            {{errMsgOfficeFax}}
          </span>
        </div>

      </div>
      <BaseButtonGroup>
        <button type="button" @click="handleRouting('previous')">Previous</button>
        <CustomButton @click="handleRouting('next')">
          Next
        </CustomButton>
      </BaseButtonGroup>
    </div>
  </div>
</template>


<script setup>
import * as COMMONS from '../../../store/_commons'; 
import { useStore } from 'vuex'; 
import { useRouter } from 'vue-router';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import ContactPhone from '@/components/contact/ContactPhone';
import ContactEmail from '@/components/contact/ContactEmail';
import CustomButton from '../../CustomButton.vue';
import { ref, computed, onMounted  } from 'vue';
import { usePhoneFormatter } from '@/composables/usePhoneFormatter';

// Contact Name (No Confirm)
const myContactName = ref('');
const isValidContactName = ref(true);
const errMsgContactName = ref('');

// Office Email (With Confirm)
const myOfficeEmail = ref('');
const myConfirmOfficeEmail = ref('');
const isOfficeEmailValidated = ref(true);
const isConfirmOfficeEmailValidated = ref(true);
const isValidOfficeEmail = ref(true);
const isValidConfirmOfficeEmail = ref(true);
const validateOfficeEmail = ref(true);
const errMsgOfficeEmail = ref('');
const errMsgConfirmOfficeEmail = ref('');
const errMsgCommonOfficeEmail = ref('');

// Cell Phone (With Confirm)
const myCellPhone = ref('');
const myConfirmCellPhone = ref('');
const isCellPhoneValidated = ref(true);
const isConfirmCellPhoneValidated = ref(true);
const isValidCellPhone = ref(true);
const isValidConfirmCellPhone = ref(true);
const validateCellPhone = ref(true);
const errMsgCellPhone = ref('');
const errMsgConfirmCellPhone = ref('');
const errMsgCommonCellPhone = ref('');

// Office Phone (No Confirm)
const myOfficePhone = ref('');
const isOfficePhoneValidated = ref(true);
const isValidOfficePhone = ref(true);
const errMsgOfficePhone = ref('');

// Office Fax (No Confirm)
const myOfficeFax = ref('');
const isOfficeFaxValidated = ref(true);
const isValidOfficeFax = ref(true);
const errMsgOfficeFax = ref('');

const verify = ref(true); 
const isComponentValid = ref(true);

// Refs for child components
const officePhoneRef = ref(null);
const officeFaxRef = ref(null);

const contactEmailRef  = ref(null); 
const contactReenterEmailRef  = ref(null);
const contactPhoneRef  = ref(null);
const contactReenterPhoneRef  = ref(null);

// Use the phone formatter composable
const { formatPhoneForRims } = usePhoneFormatter();

// Vuex Store
const store = useStore(); 

const router = useRouter(); 

const updateContact = computed(() => {
  return store.state.guestLogin.updateContact;
});

const contactInfo = computed(() => store.state.guestLogin.loginUserDetails);

const networkResponse = computed(() => store.state.networkResponse);

const hasMfaFields = computed(() => {
  return !!(updateContact.value?.officeEmail || updateContact.value?.cellPhone);
});

const hasNonMfaFields = computed(() => {
  return !!(updateContact.value?.contactPersonName || updateContact.value?.officePhone || updateContact.value?.officeFax);
});

//Lifecycle hook
onMounted(() => {
  window.scroll(0,0);
  document.body.setAttribute("tabindex", "1");
  document.body.focus();
  document.body.removeAttribute("tabindex");
  document.getElementById("app").scrollTop = 0;

  // Clear any previous messages
  store.commit('setState', { property: 'networkResponse', value: null });
});

// Methods
const getGuestSendMfaRequest = (data) => {
  store.dispatch(COMMONS.GUEST_SEND_MFA_REQUEST, data);
};

const handleRouting = async (info) => {
  if (info === 'previous') {
    store.state.guestLogin.contactUpdateStep = 1;
    return;
  }

  if (info !== 'next') return;

  await resetValidate();
  const isValid = await checkValidate();

  if (!isValid) return;

  // Determine which fields are being updated
  const hasMfaFields = updateContact.value.officeEmail || updateContact.value.cellPhone;
  const hasNonMfaFields = updateContact.value.contactPersonName || updateContact.value.officePhone || updateContact.value.officeFax;

  if (hasNonMfaFields && !hasMfaFields) {
    // Only non-MFA fields
    await updateNonMfaFieldsOnly();
  } else if (hasMfaFields && !hasNonMfaFields) {
    // Only MFA fields
    sendMfa();
  } else if (hasMfaFields && hasNonMfaFields) {
    // Both MFA and non-MFA fields
    await updateBothMfaAndNonMfa();
  }
};

// Update only non-MFA fields
const updateNonMfaFieldsOnly = async () => {
  const contactData = {
    contactPersonName: myContactName.value || undefined,
    officePhone: myOfficePhone.value ? formatPhoneForRims(myOfficePhone.value) : undefined,
    officeFax: myOfficeFax.value ? formatPhoneForRims(myOfficeFax.value) : undefined
  };

  try {
    const result = await store.dispatch(COMMONS.GUEST_UPDATE_BUSINESS_CONTACT_NON_MFA, contactData);
    
    if (result && result.status === 200) {
      router.push({ name: 'BusinessProfile' });
    }
  } catch (error) {
    console.error(error);
  }
};

// Update both MFA and non-MFA fields
const updateBothMfaAndNonMfa = async () => {
  // update non-MFA fields
  const contactData = {
    contactPersonName: myContactName.value || undefined,
    officePhone: myOfficePhone.value ? formatPhoneForRims(myOfficePhone.value) : undefined,
    officeFax: myOfficeFax.value ? formatPhoneForRims(myOfficeFax.value) : undefined
  };

  try {
    const result = await store.dispatch(COMMONS.GUEST_UPDATE_BUSINESS_CONTACT_NON_MFA, contactData);

    // Proceed with MFA flow if non-MFA update succeeded
    if (result && result.status === 200) {
      // proceed with MFA flow
      sendMfa();
    }
  } catch (error) {
    console.error(error);
  }
};

const sendMfa = () => {  
  // Store all contact info 
  const allContactInfo = {
    // MFA fields 
    email: myOfficeEmail.value || undefined,
    phone: myCellPhone.value ? formatPhoneForRims(myCellPhone.value) : undefined,
    // Keep business-specific names for additional fields
    contactPersonName: myContactName.value || undefined,
    officeEmail: myOfficeEmail.value || undefined,
    cellPhone: myCellPhone.value || undefined,
    officePhone: myOfficePhone.value ? formatPhoneForRims(myOfficePhone.value) : undefined,
    officeFax: myOfficeFax.value ? formatPhoneForRims(myOfficeFax.value) : undefined
  };
  
  // Set in store BEFORE MFA request
  store.state.guestLogin.contactUpdateInfo = allContactInfo;
  
  // Send only MFA fields to API (email and phone)
  const mfaData = {
    email: allContactInfo.email,
    phone: allContactInfo.phone
  };
  
  getGuestSendMfaRequest(mfaData);

  const isPaperOtp = contactInfo.value?.isPaperOtpSent;

  if (!isPaperOtp) {
    checkValidate();
  }
};


// eslint-disable-next-line no-unused-vars
const continueToNextStep = async () => {
  if (ContactPhone.value) {
    if (ContactPhone.value.myPhone && ContactPhone.value.myPhone.length > 0) {
      await ContactPhone.value.checkPhone();
      isCellPhoneValidated.value = ContactPhone.value.invalidPhone;
      if (isCellPhoneValidated.value) {
        return; 
      }
    }
  } else {
    console.warn("ContactPhone ref not found. Skipping phone validation check.");
  }
  
  // Update parent's overall validation state
  isComponentValid.value = !isCellPhoneValidated.value; 
};

const checkValidate = async () => {

  if (updateContact.value.contactPersonName) {
    await validateContactNameField();
  }
  
  if (updateContact.value.officeEmail) {
    await validateOfficeEmailFields();
  }

  if (updateContact.value.cellPhone) {
    await validateCellPhoneFields();
  }

  if (updateContact.value.officePhone) {
    await validateOfficePhoneFields();
  }

  if (updateContact.value.officeFax) {
    await validateOfficeFaxFields();
  }

  return emailAndPhoneValidation();
};

const validateContactNameField = async () => {
  const contactPersonName = myContactName.value.trim();

  if (!contactPersonName) {
    isValidContactName.value = false;
    errMsgContactName.value = 'Contact name is required';
    return false;
  }

  return true;
};

// Office Email Validation (With Confirm)
const validateOfficeEmailFields = async () => {
  const email = myOfficeEmail.value;
  const confirmEmail = myConfirmOfficeEmail.value;

  if (!email) {
    validateOfficeEmail.value = false;
    isValidOfficeEmail.value = false;
    errMsgOfficeEmail.value = 'Office email is required';
  }

  if (!confirmEmail) {
    validateOfficeEmail.value = false;
    isValidConfirmOfficeEmail.value = false;
    errMsgConfirmOfficeEmail.value = 'Confirm office email is required';
  }

  if (email && confirmEmail) {
    if (email === confirmEmail) {
      validateOfficeEmail.value = isValidOfficeEmail.value && isValidConfirmOfficeEmail.value;
    } else {
      validateOfficeEmail.value = false;
      errMsgCommonOfficeEmail.value = 'Office email and Confirm office email values do not match';
    }
  }
};

// Cell Phone Validation (With Confirm)
const validateCellPhoneFields = async () => {
  if (contactPhoneRef.value) {
    await contactPhoneRef.value.checkPhone();
    isCellPhoneValidated.value = await contactPhoneRef.value.hasValidPhone();
  }

  if (contactReenterPhoneRef.value) {
    await contactReenterPhoneRef.value.checkPhone();
    isConfirmCellPhoneValidated.value = await contactReenterPhoneRef.value.hasValidPhone();
  }

  const phone = myCellPhone.value;
  const confirmPhone = myConfirmCellPhone.value;

  if (!phone) {
    validateCellPhone.value = false;
    isValidCellPhone.value = false;
    errMsgCellPhone.value = 'Cell phone is required';
  }

  if (!confirmPhone) {
    validateCellPhone.value = false;
    isValidConfirmCellPhone.value = false;
    errMsgConfirmCellPhone.value = 'Confirm cell phone is required';
  }

  if (phone && confirmPhone) {
    if (phone === confirmPhone) {
      validateCellPhone.value = isValidCellPhone.value && isValidConfirmCellPhone.value;
    } else {
      validateCellPhone.value = false;
      errMsgCommonCellPhone.value = 'Cell phone and Confirm cell phone values do not match';
    }
  }
};

// Office Phone Validation (No Confirm)
const validateOfficePhoneFields = async () => {
  if (officePhoneRef.value) {
    await officePhoneRef.value.checkPhone();
    isOfficePhoneValidated.value = await officePhoneRef.value.hasValidPhone();
  }

  const phone = myOfficePhone.value;

  if (!phone) {
    isValidOfficePhone.value = false;
    errMsgOfficePhone.value = 'Office phone is required';
    return false;
  }

  return isOfficePhoneValidated.value;
};

// Office Fax Validation (No Confirm)
const validateOfficeFaxFields = async () => {
  if (officeFaxRef.value) {
    await officeFaxRef.value.checkPhone();
    isOfficeFaxValidated.value = await officeFaxRef.value.hasValidPhone();
  }

  const fax = myOfficeFax.value;

  if (!fax) {
    isValidOfficeFax.value = false;
    errMsgOfficeFax.value = 'Office fax is required';
    return false;
  }

  return isOfficeFaxValidated.value;
};

const emailAndPhoneValidation = () => {
  let isValid = true;

  if (updateContact.value.contactPersonName) {
    isValid = isValid && isValidContactName.value;
  }

  if (updateContact.value.officePhone) {
    isValid = isValid && isValidOfficePhone.value && isOfficePhoneValidated.value;
  }

  if (updateContact.value.officeFax) {
    isValid = isValid && isValidOfficeFax.value && isOfficeFaxValidated.value;
  }

  if (updateContact.value.officeEmail) {
    isValid = isValid && validateOfficeEmail.value && isOfficeEmailValidated.value && isConfirmOfficeEmailValidated.value;
  }

  if (updateContact.value.cellPhone) {
    isValid = isValid && validateCellPhone.value && isCellPhoneValidated.value && isConfirmCellPhoneValidated.value;
  }

  return isValid;
};

const resetValidate = async () => { 
  // Contact Name
  isValidContactName.value = true;
  errMsgContactName.value = '';
  
  // Office Email
  isValidOfficeEmail.value = true;
  isValidConfirmOfficeEmail.value = true;
  validateOfficeEmail.value = true;
  errMsgCommonOfficeEmail.value = '';
  
  // Cell Phone
  isValidCellPhone.value = true;
  isValidConfirmCellPhone.value = true;
  validateCellPhone.value = true;
  errMsgCommonCellPhone.value = '';
  
  // Office Phone
  isValidOfficePhone.value = true;
  errMsgOfficePhone.value = '';
  
  // Office Fax
  isValidOfficeFax.value = true;
  errMsgOfficeFax.value = '';
};

// Setters for Office Email (With Confirm)
const setEmail = (data) => {
  myOfficeEmail.value = data.email; 
  isOfficeEmailValidated.value = data.isValid;
};

const setConfirmEmail = (data) => {
  myConfirmOfficeEmail.value = data.email; 
  isConfirmOfficeEmailValidated.value = data.isValid;
};

// Setters for Cell Phone (With Confirm)
const setPhone = async (data) => {
  myCellPhone.value = data.phone; 
  isCellPhoneValidated.value = data.isValid;
  if (contactPhoneRef.value) {
    isCellPhoneValidated.value = await contactPhoneRef.value.invalidPhone;
  }
};

const setConfirmPhone = async (data) => {
  myConfirmCellPhone.value = data.phone; 
  isConfirmCellPhoneValidated.value = data.isValid;
  if (contactReenterPhoneRef.value) {
    isConfirmCellPhoneValidated.value = await contactReenterPhoneRef.value.invalidPhone;
  }
};

// Setters for Office Phone (No Confirm)
const setOfficePhone = async (data) => {
  myOfficePhone.value = data.phone; 
  isOfficePhoneValidated.value = data.isValid;
  if (officePhoneRef.value) {
    isOfficePhoneValidated.value = await officePhoneRef.value.invalidPhone;
  }
};

// Setters for Office Fax (No Confirm)
const setOfficeFax = async (data) => {
  myOfficeFax.value = data.phone; 
  isOfficeFaxValidated.value = data.isValid;
  if (officeFaxRef.value) {
    isOfficeFaxValidated.value = await officeFaxRef.value.invalidPhone;
  }
};

const resetVerify = () => {
  console.log('(no action needed)');
};

defineExpose({
  isComponentValid,
  continueToNextStep
});
</script>

<style lang="scss" scoped>
.err-msg{
  color: var(--ri-red);
}

.field-group {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
  
  &:last-child {
    border-bottom: none;
  }
}

.field-label {
  display: block;
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.app-input {
  min-width: 320px;
}

.component-container {
  .app-error-msg{
    color: var(--ri-red);
    margin-top: 10px;
    display: block;
  }
  .app-contact-inputs {
    .app-contact-info{
      .app-user-email{
        min-width: 350px;
      }
    }
    .app-input-group{
      margin-bottom: 0em !important;
    }
  } 
}

button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.update-message {
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  font-weight: 500;
  
  &.success-message {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }
  
  &.error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
}
</style>